import { useQuery, useQueryClient } from 'react-query'
import { useMatch, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUser } from '../store/slices/appSlice'

const useUser = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const loginMatch = useMatch('/auth/*')
  const queryClient = useQueryClient()

  const fetchFunc = () => {
    const shouldFetchFromProsang = queryClient.getQueryState('get-user')?.isInvalidated

    return axios
      .get('/api/user', {
        params: {
          fromServer: shouldFetchFromProsang ? true : null,
        },
      })
      .then((response) => response.data.user)
      .then((userResponse) => {
        dispatch(setUser(userResponse))
        return userResponse
      })
      .catch(() => {
        if (!window.location.href.includes('/auth')) {
          navigate('/auth/logout') // Only logout if not already on the logout or login page to prevent loops
        }
      })
  }

  return useQuery('get-user', fetchFunc, {
    staleTime: 1000 * 5 * 60, // 5 minutes
    enabled: !loginMatch,
  })
}

export default useUser
